import React from "react";

export default function CandidateControls() {
  return <div>{false ? <div>CandidateControls</div> : null}</div>;
}
